import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Close from '@material-ui/icons/Close';
import DeleteConfirm from '../../../components/DataTable/DeleteConfirm';
import UserService from '../../../services/UserService/UserService';

const useStyles = makeStyles((theme) => ({
    input: {
        backgroundColor: "#f2f2f2",
        color: "#d6d6d6",
    },
    bottomSection: {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
    },
    formControl: {
        backgroundColor: "#F2F2F2 !important",
        width: "100%",
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    button: {
        border: "none",
        borderRadius: "5px",
        width: 100,
        height: 35,
        float: "right",
        "&:focus": {
            outline: "none",
        },
    },
    submit: {
        color: "white",
        marginLeft: 15,
        height: "100%",
        backgroundColor: "#079063",
        cursor: "pointer",
    },
}));

const ApiKeyGenerator = ({ setOpen }) => {
    const [apiKey, setApiKey] = useState("");
    const [openDelete, setOpenDelete] = useState(false);
    const classes = useStyles();
    const { t } = useTranslation();
    const copyText = useRef(null);

    useEffect(() => {
        getAPIKey();
    }, [apiKey]);

    const getAPIKey = async () => {
        let response = await UserService.getAPIKey();
        if (response?.status) {
            setApiKey(response?.data?.apiKey);
        }
    }

    const handleFocus = (event) => event.target.select();

    const handleClose = () => {
        setOpen(false);
    };

    const handleGenerateAPIKey = async () => {
        const res = await UserService.generateAPIKey();
        if (res.status) {
            setApiKey(res.data.apiKey);
        }
    }

    const handleGenerate = () => {
        try {
            setOpenDelete(true)
        } catch (err) {
            console.error('Failed to generate: ', err);
        }

    }
    return (
        <Dialog
            id="autom-addNew-modal"
            data-test="autom-add-new"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    overflowX: "hidden"
                },
            }}
        >
            <DialogTitle
                id="alert-dialog-title"
            >
                <div id="about-title">
                    <b>{t('CONTENT.HELP-SECTIONS.API-KEY-GENERATE')}</b>
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div style={{ textAlign: "left", marginTop: 20 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <b>{t('CONTENT.HELP-SECTIONS.API-KEY')}</b>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                id="filled-size-small"
                                style={{ float: "left" }}
                                className={classes.input}
                                ref={copyText}
                                value={apiKey}
                                variant="outlined"
                                size="small"
                                readOnly
                                fullWidth
                                onFocus={handleFocus}
                            />
                        </Grid>

                        <Grid item xs={3}>
                            {openDelete && <DeleteConfirm setOpenDelete={setOpenDelete}
                                message={`${t('CONTENT.HELP-SECTIONS.GENERATE-WARNING')}`}
                                deleteFunc={handleGenerateAPIKey} />}
                            <Button
                                type="button"
                                onClick={() => handleGenerate()}
                                data-test="createautom-button"
                                className={`${classes.button} ${classes.submit}`}
                                style={{ backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", border: "none" }}
                            >
                                {t("CONTENT.HELP-SECTIONS.GENERATE")}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions
                style={{
                    justifyContent: "space-between",
                    padding: "8px 24px 16px 24px",
                }}
            >

            </DialogActions>
        </Dialog>
    );
};

export default ApiKeyGenerator;
